import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppFooter, { FOOTER_HEIGHT } from './AppFooter';
import AppHeader, { HEADER_HEIGHT } from './AppHeader';

export default function AppLayout() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'grid',
                gridTemplateRows: `${HEADER_HEIGHT}px 1fr ${FOOTER_HEIGHT}px`,
                bgcolor: '#f6f8fa',
            }}
        >
            <AppHeader />

            <Box
                component="main"
                sx={{
                    px: 2,
                    py: 2,
                    minWidth: 0,
                    overflowX: 'hidden',
                    height: `calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT}px)`,
                }}
            >
                <Outlet />
            </Box>

            <AppFooter />
        </Box>
    );
}